import {observer} from "mobx-react";
import {registrationStore, registrationValidationStore} from "../../../../store";
import {FieldInput} from "../../../ui";
import React from "react";

const AffiliatePanel = observer(function AffiliatePanel(){
  const contractPartnerIdentifierHelp =   registrationValidationStore.getFor("contractPartnerIdentifier")
    return <>
        <nav className="panel">
            <p className="panel-heading">Vertragspartner</p>
            <div className="panel-block">
                <FieldInput
                    id={'contractPartnerIdentifier'}
                    disabled={registrationStore.isReadonly}
                    value={registrationStore.contractPartnerIdentifier}
                    required={false}
                    label={"Schlüssel"}
                    onInput={v => v.currentTarget.value = v.currentTarget.value.toUpperCase()}
                    onChange={v => registrationStore.contractPartnerIdentifier = v}
                    onBlur={() => registrationStore.validate()}
                    help={contractPartnerIdentifierHelp}
                    invalid={Boolean(contractPartnerIdentifierHelp)}
                />
            </div>
        </nav>
    </>
})

export {
    AffiliatePanel
}
